import React from "react";
import {WarningGreyIcon} from "../../../../../../assests/GmsIcons";

type InputProps =  {
    id: string;
    value: string;
    placeholder: string;
    onChangeValue: (value: string) => void;
    className?: string;
    disabled?: boolean;
    error?: string | null;
}

const Input = ({ id, value, placeholder, onChangeValue, className = '', disabled = true, error }: InputProps) => {
    return (
        <div>
            <input id={id}
            className={`tw-py-1 tw-bg-transparent tw-border tw-border-[#6D788C] tw-rounded-[4px] tw-w-full tw-h-auto tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-text-sm tw-text-[#172B4D] tw-border-solid focus:tw-outline-none ${className}`}
            type='text'
            value={value}
            disabled={disabled}
            onChange={(e) => {
                onChangeValue(e.target.value);
            }}
            placeholder={placeholder}/>
            {error != null ? <p className="gap-2 tw-flex tw-items-center tw-mt-2 tw-text-sm tw-text-red-600"><WarningGreyIcon color='#E04040'/>{error}</p> : null}
        </div>
    );
}

export default Input;